import { IBoardOfDirector, ICheque, IFacilitiesItems, IInquiryResponseModel, IUserDetail, IUserProfile } from '../../../../../../src/app/core/interfaces'
import { formatPrice } from '../../../../../../src/app/core/utils/utility'
import { useMemo } from 'react'
import moment from 'jalali-moment';

const InquiryPdfExport = ({
  userDetail,
  userProfile,
  inquiryResponseData,
  listBoardOfDirector,
  listOfFacilities,
  listBoardOfDirectorFacilities,
}: {
  userDetail: IUserDetail | undefined
  userProfile: IUserProfile | undefined
  inquiryResponseData: IInquiryResponseModel | undefined
  listBoardOfDirector: IBoardOfDirector[] | undefined
  listOfFacilities: IFacilitiesItems[] | undefined
  listBoardOfDirectorFacilities: IBoardOfDirector[] | undefined
}) => {
  const backCheques: ICheque[] = inquiryResponseData?.result?.chequeList || [];
  const inquiryDate = moment(new Date()).locale('fa').format('jYYYY/jMM/jDD');

  const tableHeaders = [
    'نام',
    'بانک',
    'شناسه چک',
    // 'آخرین وضعیت',
    'تاریخ برگشت چک',
    'تاریخ اعتبار سنجی ',
    'مبلغ چک',
  ]

  const tableHeadersBoardOfDirector = ['عنوان', 'مبلغ برگشتی', 'تاریخ وصول چک', 'شناسه چک']

  const tableHeadersBoardOfDirectorFacilities = [
    'کد ملی',
    'نام نام خانوادگی',
    'سِمت',
    'مبلغ تسهیلات',
    'تاریخ تنظیم',
    'تاریخ سررسید',
    'مانده معوقه',
    'مانده بدهی',
  ]

  const checkDetails = () =>
    backCheques?.map((item) => {
      return {
        bank: item.branchDescription,
        name: inquiryResponseData?.result.name,
        bankLogo: '',
        checkId: item?.number,
        returnDate: item?.backDate.slice(0, 4) + '/' + item?.backDate.slice(4, 6) + '/' + item?.backDate.slice(6, 8),
        clearanceDate: inquiryDate,
        amount: formatPrice(item?.amount),
      }
    })

  // Returns a flat list of board members' facilities, each item includes person and facility info
  const facilitiesBoardOfDirector = useMemo(() => {
    const result: {
      nationalCode: string
      firstName: string
      lastName: string
      position?: number
      gender?: number
      facility?: any
    }[] = []

    listBoardOfDirectorFacilities?.forEach((person) => {
      person?.facilityInquiryBoardOfDirectors?.forEach((facility) => {
        result.push({
          nationalCode: person?.national,
          firstName: person?.firstName,
          lastName: person?.lastName,
          position: person?.position,
          gender: person?.gender,
          facility,
        })
      })
    })

    return result
  }, [listBoardOfDirectorFacilities])

  return (
    <div
      style={{
        width: '1000px',
        minHeight: '1123px',
        backgroundColor: 'white',
        margin: '0 auto',
        padding: 0,
        fontWeight: 'bold',
      }}
    >
      <div className=''>
        <div style={{ width: '100%', marginBottom: '3px' }}>
          <div
            style={{
              textAlign: 'center',
              width: '100%',
              backgroundColor: '#A8E0F0',
              padding: '10px',
            }}
          >
            <h2>استعلام</h2>
          </div>
          <div style={{ width: '100%', display: 'table', borderCollapse: 'collapse' }}>
            <div style={{ display: 'table-row', backgroundColor: '#F0F0F0', fontWeight: 'bold' }}>
              {tableHeaders.map((header, index) => (
                <h2
                  key={index}
                  style={{
                    display: 'table-cell',
                    border: '1px solid #ddd',
                    padding: '10px',
                    textAlign: 'center',
                    width: '16.66%',
                  }}
                >
                  {header}
                </h2>
              ))}
            </div>
            {checkDetails()?.length === 0 ? (
              <div style={{ margin: '5px' }}>{'چک برگشتی وجود ندارد '}</div>
            ) : (
              checkDetails()?.map((check, rowIndex) => (
                <div key={rowIndex} style={{ display: 'table-row' }}>
                  <h3
                    style={{
                      display: 'table-cell',
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                    }}
                  >
                    {check?.name}
                  </h3>
                  <h3
                    style={{
                      display: 'table-cell',
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                      }}
                    >
                      {check?.bankLogo && (
                        <img
                          src={check?.bankLogo}
                          alt={`${check?.bank} logo`}
                          style={{ width: '30px', height: '30px', objectFit: 'contain' }}
                        />
                      )}
                      <span>{check?.bank}</span>
                    </div>
                  </h3>
                  <h3
                    style={{
                      display: 'table-cell',
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                    }}
                  >
                    {check?.checkId}
                  </h3>
                  <h3
                    style={{
                      display: 'table-cell',
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                    }}
                  >
                    {check?.returnDate}
                  </h3>
                  <h3
                    style={{
                      display: 'table-cell',
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                    }}
                  >
                    {check?.clearanceDate}
                  </h3>
                  <h3
                    style={{
                      display: 'table-cell',
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                    }}
                  >
                    {check?.amount}
                  </h3>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InquiryPdfExport
